let BCHelpers = (function() {

    function BCHelpers() {
    }

    BCHelpers.prototype.init = function init() {
        //console.log('init BCHelpers');
    }

    /**
     * Product Cart Item Title Enhancer
     */
    BCHelpers.prototype.productCartItemTitleEnhancer = function productCartItemTitleEnhancer(tags) {
        var isPlante = false;
        var isPlanteWithPot = false;
        var isBougie = false;
        var isBougieWithPot = false;
        var isRecharge = false;
        var isAllumettes = false;
        var isSinglePot = false;
        var isProductGenderFemale = true;

        var isXXS = false;

        var specieComplement = '';
        var sizeComplement = '';

        var output = '';

        if (Array.isArray(tags) == true) {
            tags.forEach(function(tag) {
                if (tag == 'plantes-pot') {
                    isPlanteWithPot = true;
                }

                if (tag == 'bougies-pot') {
                    isBougieWithPot = true;
                }

                if (tag == 'Recharges') {
                    isRecharge = true;
                }

                if (tag == 'Plantes') {
                    isPlante = true;
                }

                if (tag == 'bougies') {
                    isBougie = true;
                }

                if (tag == 'XXS') {
                    isXXS = true;
                }

                if (tag == 'Allumettes') {
                    isAllumettes = true;
                }

                if (tag == 'single-pot') {
                    isSinglePot = true;
                    isProductGenderFemale = false;
                }
            });
        }

        if (Array.isArray(tags) == true) {
            tags.forEach(function(tag) {

                // Check for specie complement
                switch (tag) {
                    case 'Succulentes':
                        specieComplement = "Succulente";
                        break;

                    case 'Plantes et palmiers':
                        specieComplement = "Plantes et palmiers";
                        break;

                    case 'Euphorbes':
                        specieComplement = "Euphorbe";
                        break;

                    case 'Cactus':
                        specieComplement = "Cactus";
                        break;

                    case 'Sapin':
                        specieComplement = "Sapin";
                        break;

                    default:

                }

                // Check for size complement
                switch (tag) {
                    case 'XXS':
                        sizeComplement = "Miniature &nbsp; ⌀ 6cm";
                        break;

                    case 'XS':
                        sizeComplement = (isProductGenderFemale == true) ? "Petite" : "Petit";
                        sizeComplement += "&nbsp;⌀&nbsp;8cm";
                        break;

                    case 'S':
                        sizeComplement = "Standard&nbsp;⌀&nbsp;10cm";
                        break;

                    case 'M':
                        sizeComplement = (isProductGenderFemale == true) ? "Grande" : "Grand";
                        sizeComplement += "&nbsp;⌀&nbsp;14cm";
                        break;

                    case 'L':
                        sizeComplement = (isProductGenderFemale == true) ? "Très Grande" : "Très Grand";
                        sizeComplement += "&nbsp;&nbsp;⌀&nbsp;18cm";
                        break;

                    case 'XL':
                        sizeComplement = "XL &nbsp;&nbsp;⌀&nbsp;24cm";
                        break;

                    default:
                }
            });

            if (isBougie == true) {
                tags.forEach(function(tag) {

                    // Check meches
                    switch (tag) {
                        case '4 mèches':
                            sizeComplement = "4 mèches &nbsp;—&nbsp; Grande &nbsp;⌀&nbsp;14cm";
                            break;

                        case '3 mèches':
                            sizeComplement = "3 mèches &nbsp;—&nbsp; Standard &nbsp;⌀&nbsp;10cm";
                            break;

                        case '1 mèche':
                             if (isXXS) {
                                 sizeComplement = "1 mèche &nbsp;—&nbsp; Miniature &nbsp;⌀&nbsp;6cm";
                             } else {
                                 sizeComplement = "1 mèche &nbsp;—&nbsp; Petite &nbsp;⌀&nbsp;8cm";
                             }

                            break;

                        default:
                    }
                });
            }

            output = '<span>';
            if (isRecharge == true) {
                output += "Recharge";

                if(isPlante == true) {
                    output += "plante";
                }

                if(isBougie == true) {
                    output += "bougie";
                }

                output += '</br>';
            } else {
                if(isPlanteWithPot == true) {
                    output += "Plante en pot";
                }

                if(isBougieWithPot == true) {
                    output += "Bougie";
                }

                if(isAllumettes == true) {
                    output += "Allumettes";
                }

                if(isPlanteWithPot == true || isBougieWithPot == true) {
                    output += '</br>';
                }
            }

            if (specieComplement != '') {
                output += specieComplement + ' &mdash; ';
            }

            if (sizeComplement != '') {
                output += sizeComplement;
            }

            output += '</span>';
        }

        return output;
    }

    return BCHelpers;
})();
